"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPaginatedResponseSchema = exports.SortDirectionQueryParamsSchema = exports.PaginationQueryParamsSchema = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const maxPaginationLimit = 50;
exports.PaginationQueryParamsSchema = zod_1.default.object({
    offset: zod_1.default.coerce.number(),
    limit: zod_1.default.coerce.number().max(maxPaginationLimit),
});
exports.SortDirectionQueryParamsSchema = zod_1.default.object({
    sortDirection: zod_1.default.enum(['asc', 'desc']),
});
function createPaginatedResponseSchema(itemSchema) {
    return zod_1.default.object({
        items: itemSchema.array(),
        total: zod_1.default.number(),
    });
}
exports.createPaginatedResponseSchema = createPaginatedResponseSchema;
